import React, { useState } from "react";
import TrackerCard from "./trackerCard";
import { useGetTrackerListQuery } from "../../redux/service/trackers_service";
import TrackerHistory from "./trackerHistory";

const Trackers = () => {
  const [selectedCard, setSelectedCard] = useState(null);
  //call tracker api
  const { data } = useGetTrackerListQuery();
  const clearSelectedCard = () => {
    setSelectedCard(null);
  };
  return (
    <div>
      {selectedCard && (
        <TrackerHistory
          trackerId={selectedCard?.id}
          title={selectedCard?.title}
          selectedCard={selectedCard ? true : false}
          clearSelectedCard={clearSelectedCard}
        />
      )}
      <div className="container mx-auto p-4">
        <h1 className="text-start font-bold text-3xl mb-4">Trackers</h1>
        <ul
          role="list"
          className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {data?.data?.map((tracker) => (<>
            <TrackerCard
              key={tracker.title}
              title={tracker.formatted_name}
              setSelectedCard={setSelectedCard}
              {...tracker}
            />
          </>
          ))}
        </ul>
      </div>
    </div>
  );
};
export default Trackers;
